/**
 * @generated SignedSource<<c4054d3c2cb7c4a4c50cc7ffc255f51b>>
 * @relayHash 176740e0030484c495af762dfe4e4fed
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eca7cf9c000bf43a7e44ad71c7f514d42218e2cc89475fb724f0827fd0a81048

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessAttachmentsQuery } from './src_jiraBusinessAttachmentsQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessAttachmentsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "eca7cf9c000bf43a7e44ad71c7f514d42218e2cc89475fb724f0827fd0a81048",
    "metadata": {},
    "name": "src_jiraBusinessAttachmentsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
